import React, {useState} from "react";
import s from "./styles.module.css";

const CustomInput = React.forwardRef(
  (
    {
      name,
      label,
      type = "text",
      error = false,
      helperText = "",
      fullWidth = true,
      inputRef,
      onChange,
      ...props
    },
    ref
  ) => {


    return (
      <div
        className={s.customInput}
        style={{
          border: `1px solid ${error ? "red" : "rgba(220, 222, 243, 1)"}`,
        }}
      >
        <h3 htmlFor={name} className={s.label}>
          {label}
        </h3>

        {type === "file" ? (
          <input
            id={name}
            name={name}
            type="file"
            ref={inputRef || ref}
            className={s.input}
            multiple
            onChange={onChange}
            {...props}
          />
        ) : type === "textarea" ? (
          <textarea
            id={name}
            name={name}
            ref={inputRef || ref}
            className={`${s.input} ${s.textarea}`}
            onChange={(e) => {
                if (onChange) onChange(e); // Поддержка кастомного onChange
                props?.onChange?.(e); // Уведомляем react-hook-form
            }}
            {...props}
          />
        ) : (
          <input
            id={name}
            name={name}
            type={type}
            step={name === "area" || name === "hundredth" ? "any" : undefined}
            ref={inputRef || ref}
            className={s.input}
            onChange={(e) => {
                if (onChange) onChange(e); // Поддержка кастомного onChange
                props?.onChange?.(e); // Уведомляем react-hook-form
            }}
            {...props}
          />
        )}

        {/* Текст ошибки */}
        {error && helperText && (
          <span
            style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}
          >
            {helperText}
          </span>
        )}
      </div>
    );
  }
);

export default CustomInput;
